module.exports = __webpack_public_path__ + "static/PlayfairDisplay-Bold-186952c0c9864204eb877744edf97405.woff2";